import { differenceInMinutes, format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Exercise } from "../../../models/Exercise";
import "./style.scss";
import { AiOutlineClockCircle } from "react-icons/ai";
import { BsPeople } from "react-icons/bs";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import "../../../../style/feature.scss";
import "../../../../style/hovers.scss";
import useGetTicketAndPasses from "../../../../utils/hooks/useGetTicketAndPasses";
import SingleAlertsExercise from "./status";
import { useTranslation } from "react-i18next";
import SingleExerciseDetailsModal from "./SingleExerciseDetailsModal/SingleExerciseDetailsModal";
import SingleExerciseTicketModal from "./SingleExerciseTicketModal";
import getId from "../../../../utils/getId";
import useTicketAccess from "../hooks/useTicketAccess";
import { useSearchParams } from "react-router-dom";
import { Tooltip } from "@material-ui/core";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  exercise: Exercise;
  onRefreshExercises: () => void;
}

const SingleExercise: React.FC<IProps> = ({ exercise, onRefreshExercises }) => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [open, setOpen] = useState(false);
  const [openModalTicket, setOpenModalTicket] = useState(false);
  const { ticketAccess, getTicketAccess } = useTicketAccess();
  const { getTicketsByExercise, tickets } = useGetTicketAndPasses();

  const handleModals = (value: string) => {
    if (value === "exerciseInfoModal") {
      setOpen(true);
      setOpenModalTicket(false);
    }
    if (value === "ticketsModal") {
      setOpenModalTicket(true);
      setOpen(false);
    }
  };

  useEffect(() => {
    const exerciseId = searchParams.get("exerciseId");
    if (exerciseId && getId(exercise) === exerciseId) {
      handleModals("exerciseInfoModal");
      getTicketsByExercise(exercise.exerciseGroup.objectId);
      updateTicketAccess();
    }
    //eslint-disable-next-line
  }, [searchParams, exercise]);

  const handleClose = () => {
    setOpen(false);
    const currentParams = Object.fromEntries(searchParams.entries());
    const { exerciseId, ...restParams } = currentParams;
    setSearchParams(restParams);
  };

  const handleOpenExerciseModal = () => {
    handleModals("exerciseInfoModal");
    getTicketsByExercise(exercise.exerciseGroup.objectId);
    updateTicketAccess();
    const currentParams = Object.fromEntries(searchParams.entries());
    setSearchParams({ ...currentParams, exerciseId: getId(exercise) });
  };

  const updateTicketAccess = () => {
    getTicketAccess(exercise);
  };

  return (
    <>
      <div className={`single-exercise ${exercise.status !== "A" ? "single-exercise-past" : ""}`}>
        <div className="exercise-line" style={{ backgroundColor: exercise.buttonCollor }}></div>
        <div className="exercise-content">
          <div className="alerts-line">
            <SingleAlertsExercise
              waitListPosition={exercise.waitListPosition}
              waitList={exercise.waitList}
              assigned={exercise.assigned}
              startTime={exercise.startTime}
              saleFrom={exercise.saleFrom}
              status={exercise.status}
            />
          </div>

          {getId(exercise.deputyHumanIds) && (
            <Tooltip title={t("zastepstwo")}>
              <div style={{ position: "absolute", top: "-20px", left: "-20px", zIndex: 1 }}>
                <EAAlert message="" type="warning" compact />
              </div>
            </Tooltip>
          )}

          <div className="flex-between-center">
            <b className="flex-start-center">
              <AiOutlineClockCircle className="icon" style={{ color: exercise.buttonCollor }} />
              {format(exercise.startTime, "HH:mm")}
            </b>
            <b>{differenceInMinutes(exercise.closeTime, exercise.startTime)} min.</b>
          </div>

          <div className="exercise-name-zone">
            <strong dangerouslySetInnerHTML={{ __html: exercise.name }}></strong>
            {exercise.human.displayName && <b>{exercise.humanName}</b>}
          </div>

          <div className="flex-between-center footer-buttons">
            <button
              style={{
                backgroundColor: exercise.buttonCollor,
                borderColor: exercise.buttonCollor,
              }}
              className="move-up button small padding-small button-fill-main"
              onClick={handleOpenExerciseModal}
            >
              {t("sprawdz")}
            </button>

            <b className="flex-start-center">
              <BsPeople className="icon" style={{ color: exercise.buttonCollor }} />
              {exercise.reserved + exercise.prereservation}/{exercise.capacity}
            </b>
          </div>
        </div>

        <div className="background-overlay" style={{ backgroundColor: exercise.buttonCollor }}></div>
      </div>

      {open && (
        <SingleExerciseDetailsModal
          exercise={exercise}
          onClose={handleClose}
          ticketsListLength={tickets.length}
          handleModals={handleModals}
          onRefreshExercises={onRefreshExercises}
        />
      )}

      {openModalTicket && (
        <SingleExerciseTicketModal
          exercise={exercise}
          onClose={() => setOpenModalTicket(false)}
          tickets={tickets}
          ticketAccess={ticketAccess}
        />
      )}
    </>
  );
};

export default SingleExercise;
